import React from 'react';
import { useNavigate } from 'react-router-dom';
import { breadcrumbsStyle } from './styles';
import { Breadcrumbs, Typography, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeCapitalize } from 'utils';
import { CustomHelmet } from '../tooltip';

export const CustomBreadcrumbs = ({ parent, parentLink, child, saveParams = {} }) => {
    const classes = breadcrumbsStyle();
    const navigate = useNavigate();

    const handleClick = (event) => {
        event.preventDefault();
        // if (parentLink === '/claims') {
        //     navigate(parentLink, { tabType: info?.tabType });
        // } else {
        navigate(parentLink, { state: { ...saveParams } });
        // }
    };

    return (
        <div>
            <CustomHelmet title={`${parent} - ${child}`} />
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link className={classes.parent} href={parentLink} onClick={handleClick}>
                    {parent}
                </Link>
                <Typography className={classes.child}>{makeCapitalize(child)}</Typography>
            </Breadcrumbs>
        </div>
    );
};
